var _rect, _circle, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "plus-circle_7_",
    "data-name": "plus-circle (7)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7076",
    "data-name": "Rectangle 7076",
    width: 23,
    height: 23,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_598",
    "data-name": "Ellipse 598",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(3 3)",
    fill: "#2580ec"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_227",
    "data-name": "Line 227",
    x2: 6,
    transform: "translate(8.5 11.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_228",
    "data-name": "Line 228",
    y2: 6,
    transform: "translate(11.5 8.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.a7528d9166ac406b431cab22a6b3fd8e.svg";
export { ForwardRef as ReactComponent };